import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  readonly USERNAME_KEY = 'username';
  readonly TOKEN_KEY = 'token';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    // if there is no username and password just let the request pass
    if (isNullOrUndefined(username) || isNullOrUndefined(token)) {
      return next.handle(req)
    } else {
      const tokenHeader = localStorage.getItem('username') + ':' + localStorage.getItem('token');
      const authorizedReq = req.clone({headers: req.headers.set('token', tokenHeader)});
      return next.handle(authorizedReq);
    }
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/token.interceptor.ts